<template>
  <div class="c-trend">
    <div>
    <span class="c-trend__header">测-学知识点趋势图</span>
    <div class="c-trend__bgc">
      <div class="knowledge-trend"></div>
    </div>
    </div>
    <ClassCompare v-bind="$attrs"/>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import ClassCompare from './class-compare.vue';

export default {
  name: 'KnowledgeTrend',
  props: {
    codeTrend: {
      default: () => [],
      require: true,
    },
  },
  components: {
    ClassCompare,
  },
  data() {
    return {
      total: 234,
    };
  },
  watch: {
    codeTrend() {
      this.initCharts();
    },
  },
  methods: {
    insertStr(soure, start) {
      return `${soure.slice(0, start)}/${soure.slice(start)}`;
    },
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.knowledge-trend'));
      // 绘制图表
      myChart.setOption({
        title: {
          text: '知识点数',
          top: 25,
          left: 30,
          textStyle: {
            fontSize: 16,
            fontWeight: 500,
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['总共测学知识点', '发现漏洞知识点数', '攻克知识点数'],
          top: 25,
          right: 24,
          textStyle: {
            color: '#fff',
          },
          icon: 'circle',
        },
        grid: {
          // containLabel: true,
          top: 84,
        },
        xAxis: {
          type: 'category',
          data: this.codeTrend.map((item) => this.insertStr(item.date.slice(0, 6), 4)),
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: '12',
            },
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: ['rgba(255, 255, 255, 0.3)'],
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: '12',
            },
          },
        },
        series: [
          {
            name: '总共测学知识点',
            type: 'line',
            data: this.codeTrend.map((item) => item.tag_code_num),
            lineStyle: {
              color: '#02CBFA',
            },
            itemStyle: {
              color: '#02CBFA',
            },
          },
          {
            name: '发现漏洞知识点数',
            type: 'line',
            data: this.codeTrend.map((item) => item.weak_tag_code_num),
            lineStyle: {
              color: '#EB1313',
            },
            itemStyle: {
              color: '#EB1313',
            },
          },
          {
            name: '攻克知识点数',
            type: 'line',
            data: this.codeTrend.map((item) => item.conquer_tag_code_num),
            lineStyle: {
              color: '#F5C309',
            },
            itemStyle: {
              color: '#F5C309',
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-trend{
  box-sizing: border-box;
  width: 1823px;
  height: 676px;
  padding: 26px 40px 0 46px;
  background: url('../../images/knowledge_class_bg.png') no-repeat ;
  background-size:contain;
  display: flex;
   &__header {
     display: block;
    position: relative;
    font-size: 28px;
    font-weight: 500;
    text-indent: 1em;
    color: #E3E2FF;
    &::before {
      content: '';
      position: absolute;
      width: 27px;
      height: 27px;
      top: 9px;
      left: -8px;
      background: url('../../images/cockpit-icon.png') no-repeat center / contain;
    }
  }
    &__bgc{
    margin-top:30px ;
    position: relative;
    width: 610px;
    height: 542px;
    background: linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    border-radius: 8px ;
    // opacity: 0.38;
    }
    .knowledge-trend{
      position: absolute;
      top: 0;
      left: 0;
      width: 610px;
      height: 542px;
    }
}
</style>
